<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <figure class="image">
            <img :src="require('@/assets/images/JPEG/MyGymChecker-Logo-JPEG-BlackBlue-transparent.jpg')">
        </figure>
        <h1 class="title">Error: 404</h1>
        <h1 class="title">Oops! Page not found!</h1>
        <h1 class="title">The page you are looking for is at another gym!</h1>
        <button class="button is-large search-button slide-left" @click="$router.push('/')">Find the gym for you!</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>

.hero{
  background-color: #EBF0F1;
}

.search-button {
    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.2)
}

</style>